import { useNavigate } from "react-router";
import PageMeta from "../../../components/common/PageMeta";
import PageBreadcrumb from "../../../components/common/PageBreadCrumb";
import NewWebhookForm from "../../../components/apps/webhooks/NewWebhookForm";

export default function NewWebhook() {
    const navigate = useNavigate();

    // Função para voltar à página anterior
    const handleGoBack = () => {
        navigate(`/apps/webhooks`);
    };

    return (
        <>
            <PageMeta
                title="Sellyo - Novo Webhook"
                description="Criar novo webhook"
            />
            <PageBreadcrumb
                pageTitle="Novo Webhook"
                showBackButton={true}
                onBack={handleGoBack}
            />

            <div className="container mx-auto px-4 md:px-6">
                <NewWebhookForm
                    onSuccess={() => {
                        // Redirecionar para a página de edição do produto na aba de webhooks
                        navigate(`/apps/webhooks`);
                    }}
                    onError={(error) => {
                        console.error("Erro ao criar webhook:", error);
                    }}
                />
            </div>
        </>
    );
}